import { AxiosError, InternalAxiosRequestConfig } from 'axios'
import AuthorizationContext, { DestinationAuthorityMap, OfficeTokenPayload } from '../../context/AuthorizationContext'
import { Destination } from '../../context/AxiosContext'
import { useContext, useEffect, useRef } from 'react'
import { jwtDecode } from 'jwt-decode'

export default function useTokenInjector() {
    const props = useContext(AuthorizationContext)
    const tokensRef = useRef(props.tokens)
    const getBaseUrlRef = useRef(props.getBaseUrl)

    // Keep refs in sync with latest context values
    useEffect(() => {
        console.debug('useTokenInjector: updating tokens ref')
        tokensRef.current = props.tokens
    }, [props.tokens])
    useEffect(() => {
        console.debug('useTokenInjector: updating getBaseUrl ref')
        getBaseUrlRef.current = props.getBaseUrl
    }, [props.getBaseUrl])

    return (config: InternalAxiosRequestConfig): Promise<InternalAxiosRequestConfig> | InternalAxiosRequestConfig => {
        // Only intercept when the base URL should default to the server. This way we don't send
        // headers to ineligible hosts.
        if ((!config.baseURL && !(config.url || '').match(/^http(s)?:\/\//)) || Object.values(Destination).includes(config.baseURL as Destination)) {
            const destination = (config.baseURL as Destination) || Destination.Hammock
            config.baseURL = getBaseUrlRef.current?.(destination)
            config.headers['Destination'] = destination
        } else if (!config.headers['Destination'] || config.headers['Authorization']) {
            return config
        }

        // Add token to the request.
        const destination = config.headers['Destination'] as Destination
        const authority = DestinationAuthorityMap.get(destination)
        const token = tokensRef.current?.[authority]

        if (token?.access_token) {
            const decodedToken = jwtDecode<OfficeTokenPayload>(token?.access_token)
            console.debug('AuthorizationProvider: useTokenInjector: using', destination, 'token:', decodedToken.uti)
        }

        if (!token?.access_token) {
            return Promise.reject(new AxiosError(`Er is geen toegangstoken aanwezig voor '${authority}'.`, 'TOKEN_MISSING', config))
        } else if (token?.token_type !== 'Bearer') {
            return Promise.reject(
                new AxiosError(`De toegangstoken voor '${authority}' is geen bearer token (${token?.token_type}).`, 'INVALID_TOKEN_TYPE', config),
            )
        }

        config.headers['Authorization'] = `${token.token_type} ${token.access_token}`
        config.headers['Destination'] = destination
        return config
    }
}
